import { Card, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SpedDocumentInvoices from './SpedDocumentInvoices';
import SpedDocumentPurchases from './SpedDocumentPurchases';
import SpedDocumentInutilization from './SpedDocumentInutilization';

export default function SpedDocumentImportedList() {
  const [tab, setTab] = useState('purchases');

  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    setTab(searchParams.get('tab') || 'purchases');
  }, [history.location.search]);

  const tabs = [
    {
      label: 'Compras',
      key: 'purchases',
      children: <SpedDocumentPurchases />,
    },
    {
      label: 'Notas fiscais',
      key: 'invoices',
      children: <SpedDocumentInvoices />,
    },
    {
      label: 'Inutilização de numerações',
      key: 'inutilization',
      children: <SpedDocumentInutilization />,
    },
  ];

  return (
    <Card style={{ borderRadius: 8 }}>
      <Tabs
        activeKey={tab}
        onChange={(activeTab) => {
          setTab(activeTab);
          history.push(`?tab=${activeTab}`);
        }}
        items={tabs}
      />
    </Card>
  );
}
